import { createApi, createBaseQuery } from '@adv-frontend/modules-query';
import { apiV1Request } from '#shared/api/requests';
import {
    OpenApiGetCharacteristicColorsMethod,
    type OpenApiGetCharacteristicColorsResponseSuccess,
    type OpenApiGetCharacteristicColorsSearchParams,
    OpenApiGetCharacteristicColorsUrl,
    OpenApiUpdateCharacteristicColorsMethod,
    type OpenApiUpdateCharacteristicColorsRequest,
    type OpenApiUpdateCharacteristicColorsResponseSuccess,
    OpenApiUpdateCharacteristicColorsUrl,
} from '#shared/api/schema';

const ColorsListTag = 'ColorsList' as const;

const apiColors = createApi({
    name: 'entities/characteristic/api/colors',
    baseQuery: createBaseQuery(apiV1Request),
    tagTypes: [ColorsListTag],
    endpoints: (builder) => {
        return {
            getColors: builder.query<
                OpenApiGetCharacteristicColorsResponseSuccess,
                { parameters?: OpenApiGetCharacteristicColorsSearchParams }
            >({
                query: ({ parameters }) => {
                    return {
                        url: OpenApiGetCharacteristicColorsUrl,
                        method: OpenApiGetCharacteristicColorsMethod,
                        params: parameters,
                    };
                },
                providesTags: [ColorsListTag],
            }),
            updateColor: builder.mutation<
                OpenApiUpdateCharacteristicColorsResponseSuccess,
                { body: OpenApiUpdateCharacteristicColorsRequest }
            >({
                query: ({ body }) => {
                    return {
                        url: OpenApiUpdateCharacteristicColorsUrl,
                        method: OpenApiUpdateCharacteristicColorsMethod,
                        body,
                    };
                },
                invalidatesTags: [ColorsListTag],
            }),
        };
    },
});

export const useGetCharacteristicsColorsQuery = apiColors.useGetColorsQuery;
export const updateCharacteristicColor = apiColors.endpoints.updateColor.mutate;
export const getCharacteristicsColors = apiColors.endpoints.getColors.query;
